import { MNSproCloudApi } from '..';
import { CockpitWidgetsConfigurationItem } from '../api/v2';

export class CockpitSettingsService {
  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.CockpitSettingsApiFactory(config);

    return api;
  }

  static async getCockpitWidgetsConfiguration(
    authToken: string,
    organizationId: string,
  ): Promise<CockpitWidgetsConfigurationItem> {
    const api = CockpitSettingsService.getApi(authToken);
    const response = await api.getCockpitWidgetsConfiguration(organizationId);

    return response.data;
  }

  static async createOrUpdateCockpitWidgetsConfiguration(
    authToken: string,
    organizationId: string,
    cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem,
  ): Promise<CockpitWidgetsConfigurationItem> {
    const api = CockpitSettingsService.getApi(authToken);
    const response = await api.createOrUpdateCockpitWidgetsConfiguration(
      organizationId,
      cockpitWidgetsConfigurationItem,
    );

    return response.data;
  }

  static async uploadCockpitBanner(
    authToken: string,
    organizationId: string,
    banner: File,
  ): Promise<string> {
    const api = CockpitSettingsService.getApi(authToken);
    const response = await api.uploadCockpitBanner(organizationId, undefined, banner);

    return response.data;
  }

  static async updateCockpitBannerDisabled(
    authToken: string,
    organizationId: string,
    isDisabled: boolean,
  ): Promise<void> {
    const api = CockpitSettingsService.getApi(authToken);
    await api.updateCockpitBannerDisabled(organizationId, isDisabled);
  }

  static async deleteCockpitBanner(authToken: string, organizationId: string): Promise<void> {
    const api = CockpitSettingsService.getApi(authToken);
    await api.deleteCockpitBanner(organizationId);
  }
}
